import React from 'react';

export default function Alt1({ color } = { color: 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 426 426"
      fill={color || 'currentColor'}
    >
      <path d="M296.45,214.54l.5-.49-.45-.46C296.5,213.91,296.46,214.22,296.45,214.54Z" />
      <path d="M213.18,129.73l-.25-.26-.23.23Z" />
      <path d="M128.83,213l0,0,0,0Z" />
      <path d="M211.66,297.35l.27.28.26-.26Z" />
      <path d="M296.52,213c0,.19,0,.37,0,.56l.45.46,45.34-44.57A137,137,0,0,0,258.72,84l-45.79,45.48.25.26A83.69,83.69,0,0,1,296.52,213Z" />
      <path d="M128.79,213.83c0-.25,0-.49,0-.74l0,0L83.71,257.85a137,137,0,0,0,83.54,83.7l44.68-43.92-.27-.28A83.89,83.89,0,0,1,128.79,213.83Z" />
      <path d="M212.26,129.68l.44,0,.23-.23L167.47,83.71a136.94,136.94,0,0,0-83.7,83.54l45,45.81,0,0A83.7,83.7,0,0,1,212.26,129.68Z" />
      <path d="M296.45,214.54a83.88,83.88,0,0,1-83.39,82.87c-.3,0-.58,0-.87,0l-.26.26,43.91,44.66a137,137,0,0,0,85.49-83.58L297,214.05Z" />
      <path d="M212.93,129.47,128.8,213.05l83.13,84.58,85-83.58Zm-42.79,125.6.71-83.79,83.8.27-.28,84.24Z" />
    </svg>
  );
}
